import { all } from "redux-saga/effects"
import requestPermissions from "./requestPermissions"
import requestUser from "./requestUser"

export default function* rolesFormSaga() {
  while (true) {
    yield all({
      requestPermissions: requestPermissions(),
      requestUser: requestUser(),
    })
  }
}
